module.exports = __webpack_public_path__ + "static/test4-0c7af27ea1106557975d013e2a7053a2.jpg";